module.exports = __webpack_public_path__ + "media/images/sign-ba57085dd3e9ecd3cd2352194160e250.png";